export default function TrustBar() {
  const stats = [
    {
      value: '10,000', suffix: '+', label: 'Active Users', icon: 'ri-user-line',
      img: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20stylish%20young%20people%20shopping%20online%20with%20laptops%20and%20phones%20on%20warm%20terracotta%20toned%20background%20lifestyle%20editorial%20photography%20bright%20natural%20light%20authentic%20happy%20expressions%20modern%20workspace%20aesthetic&width=400&height=300&seq=trust-users-b2n9x&orientation=landscape'
    },
    {
      value: '120', suffix: '+', label: 'Buying Guides', icon: 'ri-book-open-line',
      img: 'https://readdy.ai/api/search-image?query=Stack%20of%20stylish%20magazines%20and%20notebooks%20with%20a%20coffee%20cup%20on%20oak%20wooden%20table%20warm%20morning%20sunlight%20streaming%20through%20window%20cozy%20reading%20nook%20aesthetic%20cream%20and%20beige%20toned%20editorial%20photography&width=400&height=300&seq=trust-guides-c4p7r&orientation=landscape'
    },
    {
      value: '100', suffix: '%', label: 'Updated Daily', icon: 'ri-refresh-line',
      img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20calendar%20and%20clock%20display%20on%20minimal%20desk%20setup%20with%20fresh%20flowers%20in%20ceramic%20vase%20soft%20sunlight%20cream%20walls%20clean%20organized%20workspace%20productivity%20aesthetic%20editorial%20style&width=400&height=300&seq=trust-updates-d8s2w&orientation=landscape'
    },
    {
      value: '2026', suffix: '', label: 'Latest Version', icon: 'ri-star-line',
      img: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20laptop%20displaying%20beautiful%20data%20dashboard%20on%20minimal%20white%20desk%20alongside%20a%20small%20succulent%20plant%20natural%20sunlight%20from%20large%20window%20clean%20contemporary%20aesthetic%20editorial%20photography&width=400&height=300&seq=trust-version-e9f1h&orientation=landscape'
    },
  ];

  return (
    <section className="bg-accent-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-2xl mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Why Thousands Use<br />Vigorbuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            The <strong>Vigorbuy Spreadsheet</strong> helps users discover products faster, compare options, and save time during the buying process with our trusted resource center.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="group">
              <div className="relative rounded-xl overflow-hidden h-40 mb-4">
                <img
                  src={stat.img}
                  alt={stat.label}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="flex items-center gap-2 mb-1">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-200/60">
                  <i className={`${stat.icon} text-sm text-accent-700`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {stat.value}<span className="text-accent-600">{stat.suffix}</span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-500 pl-10">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}